import { render } from "./LicensingView.vue?vue&type=template&id=7ad4a6fe"
import script from "./LicensingView.vue?vue&type=script&lang=js"
export * from "./LicensingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__